export interface NewsItem {
  id: string;
  title: string;
  date: string;
  category: string;
  summary: string;
  cover: string;
  content: string[];
}

export const newsList: NewsItem[] = [
  {
    id: "kinnporsche-season-2",
    title: "《黑帮少爷爱上我》第二季正式官宣，原班人马回归",
    date: "2026-09-28",
    category: "新闻",
    summary:
      "备受期待的《黑帮少爷爱上我》第二季终于官宣启动，制作方确认原班主演将悉数回归，续写 Kinn 与 Porsche 的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20editorial%20image%20of%20a%20glamorous%20Thai%20BL%20drama%20press%20event%2C%20two%20handsome%20young%20Asian%20men%20in%20dark%20elegant%20suits%20under%20warm%20stage%20lights%2C%20deep%20magenta%20and%20charcoal%20tones%2C%20blurred%20crowd%20background%2C%20high%20detail&width=1200&height=800&seq=news-kinnporsche-s2&orientation=landscape",
    content: [
      "在粉丝长达数年的呼声之后，《黑帮少爷爱上我》制作方于本周正式宣布第二季进入筹备阶段。官方发布会上，主创团队与主演阵容一同亮相，确认原班人马将悉数回归。",
      "导演在采访中表示，第二季将延续第一季冷峻而炽烈的基调，同时把故事重心更多地放在两人关系的变化与成长上。剧本已进入打磨阶段，预计明年正式开拍。",
      "消息公布后迅速登上多个社交平台热搜，相关话题讨论量在数小时内突破百万。不少观众留言称，这是自己等待最久的一部续作。",
      "关于具体的上线时间与播出平台，官方表示将在筹备完成后第一时间公布，也请观众通过官方渠道获取最新信息。",
    ],
  },
  {
    id: "2026-bl-drama-preview",
    title: "2026 年最值得期待的十部泰国双男主新剧盘点",
    date: "2026-09-15",
    category: "专题",
    summary:
      "从悬疑黑帮到治愈日常，2026 年的泰国双男主题材新剧题材愈发多元。我们为你整理了十部最值得关注的作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20collage%20style%20image%20of%20multiple%20Thai%20BL%20drama%20posters%2C%20two%20young%20Asian%20men%20in%20warm%20cinematic%20portrait%2C%20soft%20rose%20and%20amber%20tones%2C%20artistic%20gradient%20background%2C%20high%20detail&width=1200&height=800&seq=news-2026-preview&orientation=landscape",
    content: [
      "过去几年，泰国双男主题材从校园甜宠一路拓展到悬疑、犯罪、医疗与都市生活，题材边界不断被拓宽。进入 2026 年，这一趋势仍在延续。",
      "在本次盘点中，我们综合了制作阵容、预告热度与观众期待值，筛选出十部最值得关注的新作。其中既有老牌制作班底的新项目，也有新锐导演的处女作。",
      "值得注意的是，越来越多作品开始关注现实议题，例如家庭关系、职业困境与自我认同，让双男主故事不再局限于恋爱本身。",
      "当然，甜宠与治愈依旧是不会缺席的主旋律。无论你偏爱哪种风格，今年的片单都不会让你失望。",
    ],
  },
  {
    id: "itold-behind-scenes",
    title: "《以你的心诠释我的爱》幕后花絮：两位主演分享拍摄心路",
    date: "2026-08-30",
    category: "报道",
    summary:
      "在普吉岛的海风里，两位主演聊起了拍摄中最难忘的瞬间，以及那段青春故事带给他们的改变。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20image%20of%20a%20Thai%20BL%20romance%20filmed%20by%20the%20sea%2C%20two%20young%20Asian%20men%20in%20casual%20shirts%20laughing%20on%20a%20sunset%20beach%2C%20warm%20orange%20and%20rose%20tones%2C%20soft%20haze%2C%20high%20detail&width=1200&height=800&seq=news-itold-bts&orientation=landscape",
    content: [
      "《以你的心诠释我的爱》以普吉岛的碧海蓝天为背景，讲述了一段关于成长与承认爱意的青春故事。多年过去，这部剧依然是许多观众心中的白月光。",
      "在近期的访谈中，两位主演回忆起拍摄时的点点滴滴。他们提到，最难的不是剧本中的情绪戏，而是要在镜头前呈现那种介于朋友与恋人之间的微妙距离。",
      "为了找到状态，导演常常带他们去海边散步、骑车、吃当地小吃，让生活的质感自然地渗进表演里。",
      "谈到这部剧带来的改变，两人都表示，观众的共鸣让他们更加坚定地相信：真诚的故事永远有力量。",
    ],
  },
  {
    id: "thai-bl-going-global",
    title: "泰国腐剧出海观察：双男主题材如何席卷亚洲市场",
    date: "2026-08-12",
    category: "专题",
    summary:
      "从区域小众到全球热议，泰剧双男主题材正经历一场前所未有的出海浪潮。这背后是怎样的产业逻辑与观众基础？",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20global%20market%20image%20about%20Thai%20BL%20drama%20export%2C%20abstract%20world%20map%20made%20of%20warm%20rose%20and%20amber%20gradient%20light%2C%20two%20young%20Asian%20men%20silhouette%2C%20modern%20clean%20background%2C%20high%20detail&width=1200&height=800&seq=news-bl-global&orientation=landscape",
    content: [
      "十年前，泰国双男主题材还主要面向本土的小众观众；如今，它已经成为出口海外的重要文化产品之一。",
      "从流媒体平台的全球发行，到线下粉丝见面会与周边衍生品，泰国腐剧正在构建一条完整的产业链。制作方越来越重视海外观众的观看习惯，字幕与配音的本地化程度也显著提升。",
      "分析人士指出，这一题材的吸引力在于它提供了细腻的情感表达与相对自由的叙事空间，能够满足不同文化背景下观众的共鸣需求。",
      "不过，快速扩张也带来了同质化与产能过载的隐忧。如何在数量增长的同时保持内容质量，将是行业接下来需要回答的问题。",
    ],
  },
  {
    id: "cutiepie-special",
    title: "《甜心派》特别篇上线，续写 Lian 与 Kuea 的甜蜜日常",
    date: "2026-07-22",
    category: "新闻",
    summary:
      "在正片收官后，《甜心派》推出特别篇，将视角对准两位主角的婚后日常，甜度依旧在线。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20image%20of%20a%20Thai%20BL%20drama%20special%2C%20two%20elegant%20young%20Asian%20men%20in%20pastel%20luxury%20outfits%20sharing%20a%20tender%20moment%2C%20soft%20golden%20light%2C%20blush%20pink%20and%20champagne%20tones%2C%20blurred%20bokeh%2C%20high%20detail&width=1200&height=800&seq=news-cutiepie-special&orientation=landscape",
    content: [
      "作为近年最受欢迎的甜宠向泰剧之一，《甜心派》在正片收官之后，再度为观众带来了惊喜——一部聚焦主角婚后生活的特别篇正式上线。",
      "特别篇延续了轻松明快的节奏，把镜头对准了 Lian 与 Kuea 柴米油盐又甜度超标的日常。两人在磨合中的小摩擦、小默契，成为最打动观众的部分。",
      "主创表示，特别篇是送给一路陪伴的观众的一份礼物，希望大家能在忙碌的生活里，看到一点简单而确定的温暖。",
    ],
  },
  {
    id: "thousandstars-director-interview",
    title: "专访《千星传说》导演：山野之间，如何拍出最温柔的告白",
    date: "2026-07-05",
    category: "报道",
    summary:
      "在村落与星空之下，导演分享了这部治愈之作的创作理念，以及他想通过故事传递的那份安静的力量。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20documentary%20style%20image%20of%20a%20misty%20mountain%20village%20at%20dusk%20with%20warm%20lantern%20lights%2C%20two%20young%20Asian%20men%20walking%20along%20a%20path%2C%20soft%20plum%20and%20amber%20tones%2C%20high%20detail&width=1200&height=800&seq=news-thousandstars-interview&orientation=landscape",
    content: [
      "在许多观众心中，《千星传说》是一部节奏舒缓却余韵悠长的作品。它把故事安放在偏远的山村，让情感在星空与山风之间缓慢生长。",
      "导演在专访中谈到，他并不想拍一部充满戏剧冲突的作品，而是希望记录那些安静的瞬间——一次守夜、一顿家常饭、一句没说出口的关心。",
      "为了呈现真实的山野质感，剧组在开拍前深入村落生活了数月，演员也与当地村民建立了深厚的情感联结。",
      "谈到最想传递给观众的东西，导演说：希望每个人都能在忙碌之外，找到属于自己的那片星空。",
    ],
  },
];